import { Paper } from "@mui/material";
import Card from "components/Dashboard/Card";

export default function Structures(props) {
  return (
    <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
      <Card
        label="Structures"
        activeKey="structures"
        row={props.estatedProperty.structures}
      />
    </Paper>
  );
}
